module.exports = __webpack_public_path__ + "static/media/mDao__euma.e40a1b48.md";